export const hunsResearch = [
    {name:"Bowman", wood: 940, clay: 540, iron: 680, crop: 520, all: 2680},
    { name: "Spotter", wood: 1120, clay: 700, iron: 360, crop: 400, all: 2580 },
    { name: "Steppe Rider", wood: 1840, clay: 1580, iron: 1720, crop: 430, all: 5570 },
    { name: "Marksman", wood: 2020, clay: 1500, iron: 2840, crop: 460, all: 6820 },
    { name: "Marauder", wood: 2800, clay: 2340, iron: 5080, crop: 1000, all: 11220 },
    { name: "Ram", wood: 6460, clay: 1420, iron: 3080, crop: 580, all: 11540 },
    { name: "Catapult", wood: 5800, clay: 5220, iron: 5160, crop: 520, all: 16700 },
    { name: "Logades", wood: 19100, clay: 14000, iron: 20560, crop: 16720, all: 70380 }
]